import React, { FC } from 'react';

import { useTranslation } from 'react-i18next';

import { useThemeMode } from '~/contexts/ThemeModeContext';

import chatwithaiBigLogoDarkTheme from '../../assets/chatwithai-big-logo-dark-theme.png';
import chatwithaiBigLogoLightTheme from '../../assets/chatwithai-big-logo-light-theme.png';
import polyIconLogoDarkTheme from '../../assets/poly-icon-logo-dark-theme.png';
import polyIconLogoLightTheme from '../../assets/poly-icon-logo-light-theme.png';
type LogoProps = {
  className?: string;
};
const ProjectLogo: FC<LogoProps> = ({ className }) => {
  const { t } = useTranslation();
  const { themeMode } = useThemeMode();
  const logoSrc =
    themeMode === 'dark' ? polyIconLogoDarkTheme : polyIconLogoLightTheme;
  return (
    <img
      src={logoSrc}
      alt={t('general:project_logo.alt')}
      className={className}
    />
  );
};
const ProjectBigLogo: FC<LogoProps> = ({ className }) => {
  const { t } = useTranslation();
  const { themeMode } = useThemeMode();
  const logoSrc =
    themeMode === 'dark'
      ? chatwithaiBigLogoDarkTheme
      : chatwithaiBigLogoLightTheme;
  return (
    <img
      src={logoSrc}
      alt={t('general:project_logo.big_alt')}
      className={className}
    />
  );
};
export { ProjectBigLogo, ProjectLogo };
